import React, { useEffect, useRef } from 'react';
import { useActor } from '@xstate/react'
// import { logEvent } from "firebase/analytics";
// import { analytics } from '../firebase';

import { service } from './machine'

export const Art = () => {
  const rendererWrapper = useRef(null);
  const [state, send] = useActor(service)
  useEffect(() => {
    // logEvent(analytics, 'land-page__Home')

    service.start()
    // service.onTransition(state => {
    //   console.log(state)
    // })
    // console.log(service.state.context)
    // rendererWrapper.current.appendChild( service.state.context.renderer.domElement );

    // document.addEventListener('keydown', e => {
    //   service.send(e.key, { pressed: true })
    // });
    // document.addEventListener('keyup', e => {
    //   service.send(e.key, { pressed: false })
    // });
    // service.onTransition(s => console.log(s))

    var animate = function () {
      requestAnimationFrame( animate );
      service.send('TICK')
    };
    animate();
  }, [])

  return (
    <div>
      {/* <div style={{color: 'white', position: 'absolute', whiteSpace: 'pre-line'}}>{ gameState }</div> */}
      <div ref={rendererWrapper} />
    </div>
  )
}
